import { Button } from '@/components/ui/button';

interface SurveyFooterProps {
    isLastQuestion: boolean;
    isSubmitDisabled: boolean;
    onSubmit: () => void;
    onBack: () => void;
}

export const SurveyFooter: React.FC<SurveyFooterProps> = ({
    isLastQuestion,
    isSubmitDisabled,
    onSubmit,
    onBack,
}) => {
    return (
        <div className="w-full min-h-[100px] p-4 flex items-center justify-center border-t border-solid border-black">
            <div className="w-full flex flex-col gap-4 md:flex-row md:justify-between md:gap-6">
                <Button
                    size="xl" className="w-full md:w-[362px]"
                    disabled={isSubmitDisabled}
                    onClick={onSubmit}
                >
                    {isLastQuestion ? "Concludi" : "Avanti"}
                </Button>
                <Button
                    variant="outline" size="xl" className="w-full md:w-[362px]"
                    onClick={onBack}
                >
                    Indietro
                </Button>
            </div>
        </div>
    );
}; 